import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

const Lead = ({ children }) => (
  <p className="text-lg md:text-xl font-bold leading-snug" style={{ color: "var(--text-primary)" }}>{children}</p>
);
const Line = ({ children }) => (
  <p className="text-base md:text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>{children}</p>
);
const Sub = ({ children }) => (
  <p className="text-base md:text-lg font-bold mt-6" style={{ color: "var(--text-primary)" }}>{children}</p>
);
const B = ({ children }) => <strong style={{ color: "var(--text-primary)" }}>{children}</strong>;

const SECTIONS = [
  {
    k: "location",
    label: "Sale Location",
    body: (
      <div className="space-y-1.5">
        <Lead>Billings Livestock Commission</Lead>
        <Line>2443 N. Frontage Rd #1, Billings, MT</Line>
        <Line><a href="tel:406-245-4151" className="link-brass">406-245-4151</a>  •  <a href="tel:800-635-7364" className="link-brass">800-635-7364</a>  •  <a href="mailto:cattlesales@billingslivestock.com" className="link-brass">cattlesales@billingslivestock.com</a></Line>
        <Line>From I-90 take exit 455, North on Johnson Lane and immediately West on I-90 Frontage Rd.</Line>
        <p className="mt-4 text-base md:text-lg font-bold" style={{ color: "var(--text-primary)" }}>
          Approximately 1:00 PM, and immediately following the Western Choice sale at noon.
        </p>
      </div>
    ),
  },
  {
    k: "schedule",
    label: "Schedule of Events",
    body: (
      <div className="space-y-1.5">
        <Sub>Before December 4, 2026</Sub>
        <Line>View the bulls and some of the heifers at Fauth Livestock, Lavina, MT.</Line>
        <Sub>Friday, December 4, 2026</Sub>
        <Line>Cattle Viewing at Billings Livestock Commission</Line>
        <Line><B>6:00 PM</B>  •  Bulls of the Big Sky and MT Simmental Association Social and Meeting</Line>
        <Sub>Saturday, December 5, 2026</Sub>
        <Line><B>8:00 AM</B>  •  Livestock Judging Contest Registration</Line>
        <Line><B>9:00 AM</B>  •  Livestock Judging Contest</Line>
        <Line><B>9:00 AM</B>  •  Cattle on Display</Line>
        <Line><B>10:00 AM</B>  •  Lunch sponsored by Bulls of the Big Sky and MSA</Line>
        <Line><B>12:00 NOON</B>  •  Western Choice Sale, immediately followed by Legacy of the Big Sky Sale</Line>
        <div className="mt-8 p-6 md:p-8" style={{ border: "2px solid var(--brass)", background: "rgba(232,215,168,0.12)" }}>
          <p className="font-bold text-base md:text-lg" style={{ color: "var(--text-primary)" }}>Join us for Dinner — Friday, December 4:</p>
          <p className="mt-2 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            Please join us Friday night at the Montana Simmental Assn. Annual Meeting. There is an educational
            presenter, a &ldquo;Fun&rdquo; Auction, semen auction and a great opportunity to visit. Let us know if you would
            like to attend and we will cover your dinner ticket. It will be a great opportunity to visit about the
            bulls and visit with other cattlemen. Dinner and social hour will be at <B>6 PM at Hampton Inn, 5110 Southgate Drive, Billings</B>.
          </p>
        </div>
      </div>
    ),
  },
  {
    k: "hotel",
    label: "Hotels & Air Travel",
    body: (
      <div className="space-y-1.5">
        <Lead>Hampton Inn</Lead>
        <Line>5110 Southgate Drive, Billings, MT  •  <a href="tel:406-248-4949" className="link-brass">406-248-4949</a></Line>
        <Line>Block of rooms under Bulls of the Big Sky through February 5.</Line>
        <Sub>Air Transportation</Sub>
        <Line>Billings Airport is serviced by Alaska, Delta, Cape Air, American Airlines, Allegiant, and United.</Line>
      </div>
    ),
  },
  {
    k: "bidding",
    label: "Sale Updates, Bidding & Payments",
    body: (
      <div className="space-y-4">
        <Lead>Sale Order will be posted by Friday Evening, December 4.</Lead>
        <Line>On <a href="https://www.bullsofthebigsky.com" className="link-brass">www.bullsofthebigsky.com</a>, <a href="https://www.dvauction.com" target="_blank" rel="noopener noreferrer" className="link-brass">www.DVAuction.com</a>, and on Facebook.</Line>
        <Sub>Online Bidding and Payments</Sub>
        <Line>Cattleusa.com will not be available for sale day. Bid live online at <a href="https://www.dvauction.com" target="_blank" rel="noopener noreferrer" className="link-brass">www.dvauction.com</a>.</Line>
        <Line>All successful bidders will be invoiced from Bulls of the Big Sky. If payment is not received prior to <B>January 15</B>, a charge of <B>$50 per bull per month</B> may be applied.</Line>
        <Sub>View this salebook and videos of the bulls online at</Sub>
        <Line>
          <a href="https://www.bullsofthebigsky.com" className="link-brass">www.bullsofthebigsky.com</a>  •{" "}
          <a href="https://www.alliedgeneticresources.com" target="_blank" rel="noopener noreferrer" className="link-brass">www.alliedgeneticresources.com</a>  •{" "}
          <a href="https://www.dvauction.com" target="_blank" rel="noopener noreferrer" className="link-brass">www.dvauction.com</a>
        </Line>
      </div>
    ),
  },
  {
    k: "contacts",
    label: "Sale Day Contacts",
    body: (
      <div className="space-y-1.5">
        <Lead>Auctioneer: Ty Thompson  •  <a href="tel:406-698-4783" className="link-brass">406-698-4783</a></Lead>
        <Sub>Sale Day Phones</Sub>
        <Line><B>Marty Ropp</B>  •  <a href="tel:406-581-7835" className="link-brass">406-581-7835</a></Line>
        <Line><B>Billings Livestock Commission</B>  •  <a href="tel:800-635-7364" className="link-brass">800-635-7364</a></Line>
        <Line><B>Maureen Mai</B>  •  <a href="tel:208-660-2726" className="link-brass">208-660-2726</a></Line>
        <Line><B>Jeff Thomas</B>  •  <a href="tel:406-581-8859" className="link-brass">406-581-8859</a></Line>
        <Line><B>Rocky Forseth</B>  •  <a href="tel:406-590-7984" className="link-brass">406-590-7984</a></Line>
        <Line><B>Jared Murnin</B>  •  <a href="tel:406-321-1542" className="link-brass">406-321-1542</a></Line>
        <Sub>Publication Representatives</Sub>
        <Line>Jeff Thomas, <em>The Prairie Star</em>  •  406-581-8859</Line>
        <Line>John Goggins, <em>Western Ag Reporter</em>  •  406-698-4159</Line>
        <Line>Kevin Murnin, <em>Western Livestock Journal</em>  •  406-853-4638</Line>
        <Line>Andy Roberts, <em>American Simmental Assn.</em>  •  406-852-4387</Line>
        <Sub>Sale Management — Allied Genetic Resources</Sub>
        <Line>Marty Ropp 406-581-7835  •  Rocky Forseth 406-590-7984  •  Corey Wilkins 256-590-2487  •  Jared Murnin 406-321-1542</Line>
        <Line><a href="https://www.alliedgeneticresources.com" target="_blank" rel="noopener noreferrer" className="link-brass">www.alliedgeneticresources.com</a></Line>
      </div>
    ),
  },
  {
    k: "health",
    label: "Health & Vaccinations",
    body: (
      <div className="space-y-4">
        <Line>
          The bulls were vaccinated and boostered at weaning time with BoviShield 5, Inforce, One Shot Ultra 8,
          (or a Bovi OneShot combo), Somnubac and Dectomax Injectable. They were again poured and boostered with
          an 8 way and Respiratory vaccines in October. All bulls have passed their fertility test as of <B>Nov. 10, 2026</B>.
          If you are waiting for spring turnout, we recommend you re-check them prior to usage. Scrotal measurements
          were taken <B>Oct. 13, 2026</B> and are listed as actual. All bulls have been tested and are negative for BVD/PI3.
        </Line>
      </div>
    ),
  },
  {
    k: "insurance",
    label: "Insurance",
    body: (
      <div className="space-y-4">
        <Lead>Insurance will be available on sale day and is recommended.</Lead>
        <Line>Bulls of the Big Sky encourage buyers to purchase insurance on the bulls for death or injury. <B>Mortality Insurance is required if Option 3 in Feed and Delivery section is selected.</B></Line>
      </div>
    ),
  },
  {
    k: "terms",
    label: "Terms, EPDs & Volume Discount",
    body: (
      <div className="space-y-4">
        <Lead>All cattle sell under the Suggested Terms and Conditions of the American Simmental Association.</Lead>
        <Sub>EPDs</Sub>
        <Line>All EPDs are the most current BOLT at the time of printing conducted by IGS and the American Simmental Association. Please note that EPDs may change from the time the sale catalog is printed until registration papers are transferred.</Line>
        <Sub>Volume Buyer Discount</Sub>
        <Line><B>Buyers purchasing 5 or more bulls will receive a 5% rebate</B> on their total purchase following delivery and before <B>March 1</B>.</Line>
      </div>
    ),
  },
  {
    k: "warranty",
    label: "Bull Warranty & Announcements",
    body: (
      <div className="space-y-4">
        <Line>
          All bulls sold are sold as guaranteed breeding sound for one breeding season, not to exceed ninety (90)
          days. This guarantee does not include loss of use due to abuse, neglect, illness due to poor nutrition or
          physical health, and/or acts of God. In the event a Buyer has any problem with a bull prior to or during
          the bull&apos;s first breeding season the Buyer shall immediately contact the breeder of the bull to report a
          claim. A statement of diagnosis from a competent veterinarian will be required with the submission of each
          claim. Bulls will be covered for unsoundness not caused by illness or foot rot. Seller reserves the right
          to demand return of the bull at the Seller&apos;s sole discretion, and/or request a second opinion from a
          veterinarian of Seller&apos;s choice. In the event of a valid claim submission, Buyer will be provided a
          replacement bull of comparable quality if Seller or any other Bulls of the Big Sky member has one
          available. In the event a replacement bull is not available, the Buyer will be given a full credit, minus
          salvage value, to be used in a future Bulls of the Big Sky sale. Bulls of the Big Sky members will not be
          held responsible, under any circumstance, for crediting any settlement amount exceeding the purchase
          price of a replacement bull. We are confident in our bulls, and we will work with any Buyer in good faith
          to correct any issues with a bull. In return, we ask the Buyers to use common sense and good management
          practices, providing adequate shelter and feed for young bulls, and keeping in mind the bull&apos;s age at
          turnout.
        </Line>
        <Sub>Announcements</Sub>
        <Line>
          Announcements made from the auction block during the sale take precedence over printed material in the
          catalog or other printed material associated with this sale. Anyone attending this sale attends at their
          own risk. Breeders and sale force will not be held responsible for any personal injury for attending this
          sale.
        </Line>
      </div>
    ),
  },
  {
    k: "delivery",
    label: "Delivery & Insurance Policy",
    body: (
      <div className="space-y-4">
        <Lead>Legacy Age-Advantaged Bull Delivery and Insurance Policy</Lead>
        <Line>Let us know at check out if you will need mortality insurance. Please read below to see what option works best for you as insurance is required for some of the options.</Line>
        <Sub>Option 1</Sub>
        <Line>
          Delivery of the bulls will be free of charge within Montana and will begin shortly after the Legacy Sale,
          anticipated to be <B>December 6th–20th</B>. Trucking outside of Montana will be arranged at the most economical
          and reasonable rate for the customer. If you require trucking outside of Montana, transportation details
          may be arranged through any Bulls of the Big Sky members or the Allied Genetic Resources sales staff.
        </Line>
        <Sub>Option 2</Sub>
        <Line>We will offer <B>$250 credit at checkout</B> if you pick your bull up at or immediately after the sale.</Line>
        <Sub>Option 3</Sub>
        <Line>
          If it is truly unfeasible for you to take immediate delivery of your bull, please let sale management know
          and you will be invoiced for an additional <B>$500 for feed and board</B>.
        </Line>
        <Line>
          If you do not take delivery of your bull immediately following the sale, you will be required to maintain
          a mortality insurance policy on your bull. Insurance will be available sale day. If you choose to winter
          your bull at Fauth Ranch, bulls must be picked up, or travel arrangements made, no later than <B>March 1, 2027</B>.
        </Line>
        <Line>
          Imagine your bull with 80 other two-year-old bulls for the winter, and the fun these big teenagers would
          have together. With that, we believe it&apos;s in the best interest of your young bull to get him home and
          settled into your program prior to breeding season.
        </Line>
      </div>
    ),
  },
  {
    k: "outofstate",
    label: "Out of State & Canadian Buyers",
    body: (
      <div className="space-y-4">
        <Sub>Notice to Out of State Buyers</Sub>
        <Line>Please know your state health requirements prior to sale day.</Line>
        <Line>
          If your state requires Trich testing on 12 months or younger, the bull(s) will not be able to leave
          Montana immediately after the sale and must return to Fauth&apos;s for testing. Though Bulls of the Big Sky
          pays for the cost of all regular health papers, the cost of Trich testing and other state specific health
          requirements will be the responsibility of the Buyer and will be billed to the Buyer.
        </Line>
        <Sub>Notice to Canadian Buyers</Sub>
        <Line>
          Bulls of the Big Sky will provide free delivery to the US side of Port of Entry at Sweetgrass, MT and pay
          for the cost of regular health papers. The Buyer is responsible for the cost of additional Canadian or
          Provincial Health Requirements.
        </Line>
      </div>
    ),
  },
  {
    k: "semen",
    label: "Retaining Semen Interest",
    body: (
      <div className="space-y-4">
        <Line>
          The bull buyer will receive full possession, 100% salvage value, and &frac34; semen interest of any bull
          purchased in this sale, while the individual selling ranch (&ldquo;Seller&rdquo;) will retain &frac14; semen interest in
          any bull that it sells. Seller&apos;s retained semen interest is a royalty interest that entitles Seller to
          &frac14; of any revenue from the sale of that bull&apos;s semen. Seller&apos;s retained semen interest shall remain even
          if the bull, or any interest in the bull, is later sold to a third-party; and, the Buyer shall be solely
          responsible for notifying any later third-party buyer of the Seller&apos;s retained semen interest and for
          ensuring that Seller&apos;s retained semen interest is satisfied if semen is ever sold. Seller will not be
          responsible for any expenses directly or indirectly related to semen collection or promotion of a
          purchased bull, unless the Buyer and Seller agree otherwise in writing prior to semen collection.
          Seller&apos;s retained semen interest also includes the right of Seller to collect semen on the purchased bull
          at Seller&apos;s sole expense and at the Buyer&apos;s reasonable convenience.
        </Line>
      </div>
    ),
  },
  {
    k: "heifers",
    label: "Commercial Bred Heifer Trucking",
    body: (
      <div className="space-y-4">
        <Line>
          Heifers must be picked up from Billings Livestock Commission within <B>forty-eight (48) hours</B> of the sale.
          Heifers will not be trucked back to their breeders. If you require trucking, cattle transportation details
          can be arranged through the Bulls of the Big Sky members or the Allied Genetic Resources sale staff.
        </Line>
      </div>
    ),
  },
  {
    k: "management",
    label: "Best Management Practices",
    body: (
      <div className="space-y-4">
        <Lead>When you get your performance-tested bull home, observing these management practices will ensure the best reproductive performance. Put good in, get good out.</Lead>
        <Line>
          Remember, your bull is a yearling or long yearling and is still growing. Feed your young bulls well. Feed
          good quality hay, five to ten pounds of grain, and one to two pounds of a protein supplement from now
          until the start of breeding season to ensure your bull continues to grow out well.
        </Line>
        <Line>
          Supply plenty of free choice salt, mineral, and clean water. Treat routinely for internal and external
          parasites. Provide shelter or windbreak from the elements and provide bedding to protect your young
          bull&apos;s testicles from freezing temperatures.
        </Line>
        <Line>Vaccinate your bulls according to your veterinarian&apos;s recommendations, including IBR, PI3, BVD, and Lepto.</Line>
        <Line>
          Plan to use your young bull in a restricted breeding season the first time and observe him closely for any
          unsoundness. Make sure the number of females he is with is appropriately governed by his age. The
          following table may be used as a guide.
        </Line>
        <div className="mt-6 max-w-sm" data-testid="bull-age-table">
          <div className="grid grid-cols-2 gap-x-8 border-b pb-2" style={{ borderColor: "var(--text-primary)" }}>
            <span className="font-bold text-sm uppercase tracking-wider" style={{ color: "var(--text-primary)" }}>Bulls Age</span>
            <span className="font-bold text-sm uppercase tracking-wider" style={{ color: "var(--text-primary)" }}>Number of Females</span>
          </div>
          {[["12 to 15 months", "10 to 12"], ["15 to 18 months", "12 to 18"], ["18 to 24 months", "18 to 25"], ["24 months & older", "25 to 35"]].map(([age, females]) => (
            <div key={age} className="grid grid-cols-2 gap-x-8 py-1.5 text-base" style={{ color: "var(--text-secondary)" }}>
              <span>{age}</span>
              <span>{females}</span>
            </div>
          ))}
        </div>
      </div>
    ),
  },
];

export default function LegacyBuyerInfoPage() {
  const [, setSettings] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Legacy Sale Buyer Information — Bulls of the Big Sky";
    api.get("/site-settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="legacy-buyer-info-page" className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <SiteHeader />

      <section className="pt-40 pb-10 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="eyebrow">Buyer Information</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.95]" data-testid="legacy-buyer-info-heading">
            Legacy Sale<br />Buyer Information
          </h1>
          <div className="font-italic-serif text-xl md:text-2xl mt-4" style={{ color: "var(--brass-deep)" }}>
            December 5, 2026  •  Billings Livestock Commission  •  Billings, Montana
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <span
              data-testid="picker-legacy"
              className="px-8 py-4 text-base font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Big Shoulders Display', sans-serif", letterSpacing: "0.15em", background: "var(--hay)", color: "#0E2C46", border: "2px solid var(--hay)" }}
            >
              Legacy Sale  ✓
            </span>
            <Link
              to="/buyer-info"
              data-testid="annual-buyer-info-link"
              className="px-8 py-4 text-base font-bold tracking-widest uppercase transition-colors hover:bg-[#1E4D75] hover:text-white"
              style={{ fontFamily: "'Big Shoulders Display', sans-serif", letterSpacing: "0.15em", border: "2px solid #1E4D75", color: "#1E4D75" }}
            >
              Annual Sale →
            </Link>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-24 md:pb-32">
        <div className="max-w-[1400px] mx-auto space-y-16 md:space-y-20">
          {SECTIONS.map((row, i) => (
            <div key={row.k} data-testid={`legacy-section-${row.k}`} className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start border-t pt-12 first:border-t-0 first:pt-0" style={{ borderColor: "var(--border-subtle)" }}>
              <div className="md:col-span-3">
                <div className="font-display text-7xl md:text-8xl" style={{ color: "rgba(30,77,117,0.4)" }}>
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="eyebrow mt-3">{row.label}</div>
              </div>
              <div className="md:col-span-9 md:pl-8 md:border-l" style={{ borderColor: "var(--border-subtle)" }}>
                {row.body}
              </div>
            </div>
          ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
